// import { Injectable } from "@angular/core";
// import { Loader, LoaderOptions } from "@googlemaps/js-api-loader";
// import { environment } from "../../environments/environment";
// import { EnvConfigService } from '../env-config.service'

// @Injectable({
//   providedIn: "root",
// })
// export class GoogleMapsLoaderService {
//   private readonly loader: Loader;

//   constructor(private readonly envService: EnvConfigService ) {
//     const googleMap = this.envService.getEnvData()
//     const googleMapKey = googleMap?.mapConfig?.websiteKey
//     const loaderOptions: LoaderOptions = {
//       apiKey: googleMapKey || environment.GoogleMapKey ,
//       version: "weekly",
//       libraries: ["places", "geometry", "drawing"], // Include required libraries here
//     };
//     this.loader = new Loader(loaderOptions);
   
    
//   }

//   load(): Promise<any> {
//     if (window.google?.maps) {
//       console.log("Google Maps API is already loaded.");
//       return Promise.resolve();
//     }
//     return this.loader.importLibrary('places');
//     // return this.loader.load().then(() => {
//     //   console.log("Google Maps API loaded successfully.");
//     // }).catch(error => {
//     //   console.error("Error loading Google Maps API:", error);
//     //   throw error; // Rethrow the error to propagate it to the caller
//     // });
//   }
// }




import { Injectable } from "@angular/core";
import { Loader, LoaderOptions } from "@googlemaps/js-api-loader";
import { environment } from "../../environments/environment";
import { EnvConfigService } from '../env-config.service';

@Injectable({
  providedIn: "root",
})
export class GoogleMapsLoaderService {
  private readonly loader: Loader;

  constructor(private readonly envService: EnvConfigService) {
    const googleMap = this.envService.getEnvData();
    const googleMapKey = googleMap?.mapConfig?.websiteKey;
    const loaderOptions: LoaderOptions = {  
      apiKey: googleMapKey || environment.GoogleMapKey,
     version: "quarterly",                                   // ✅ pinned — DrawingManager exists here
      libraries: ["places", "geometry", "drawing"],
    };
    this.loader = new Loader(loaderOptions);
  }

  load(): Promise<any> {
    if (window.google?.maps) {
      console.log("Google Maps API is already loaded.");
      return Promise.resolve();
    }

    // ✅ FIX: Use loader.load() NOT importLibrary()
    // importLibrary() ignores version pin and loads latest (v3.65) which removed DrawingManager
    // loader.load() respects the version:"3.58" pin above
    return this.loader.load().then(() => {
      console.log("Google Maps API loaded successfully.");
    }).catch((error) => {
      console.error("Error loading Google Maps API:", error);
      throw error;
    });
  }
}
